export var EPlayerSidebarStatType;
(function (EPlayerSidebarStatType) {
    EPlayerSidebarStatType["GOAL"] = "goal";
    EPlayerSidebarStatType["ASSIST"] = "assist";
})(EPlayerSidebarStatType || (EPlayerSidebarStatType = {}));
